// Older browser support fix
// https://github.com/johndatserakis/koa-vue-notes-api/issues/1
import 'es6-promise/auto'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import Toasted from 'vue-toasted'
import VModal from 'vue-js-modal'
import VueProgressBar from 'vue-progressbar'
import VueClipboard from 'vue-clipboard2'
import 'vue-progress-path/dist/vue-progress-path.css'
import VueProgress from 'vue-progress-path'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/material_blue.css'
import SocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'
import axios from 'axios'

import './assets/css/app.scss' // app styles

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Toasted, {
    theme: 'primary',
    position: 'top-center',
    duration: 2300
})
Vue.use(VModal, { dialog: true })
Vue.use(VueProgressBar, {
    color: '#ADE027',
    failedColor: '#F43D41',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
})
Vue.use(VueClipboard)
Vue.use(VueProgress)
Vue.use(flatPickr)
Vue.use(SocialSharing)
Vue.use(VueAnalytics, {
    id: 'UA-85213203-16',
    checkDuplicatedScript: true,
    router
})

// The following two interceptor blocks are strictly for
// attaching the top-loading bar to all axios requests and
// stoping the bar on all responses.
axios.interceptors.request.use(function (config) {
    router.app.$Progress.start()
    return config
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
    router.app.$Progress.finish()
    return response
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js